import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import ListingPage from './pages/ListingPage';
import DetailsPage from './pages/DetailsPage';

const App: React.FC = () => {
  return (
    <HashRouter>
      <div className="flex flex-col min-h-screen bg-slate-50">
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<ListingPage />} />
            <Route path="/property/:id" element={<DetailsPage />} />
          </Routes>
        </main>
      </div>
    </HashRouter>
  );
};

export default App;